import {
  ACTIVE_MODULE_KEYS,
  normalizeLegacyModuleKey,
  type IMultiplacerModuleKey,
} from "@multiconsult-group/multiplacer-core";

export type ModulePage = "design" | "room" | "forekomster" | "endringer";
export const MODULE_PAGES: Record<IMultiplacerModuleKey, readonly ModulePage[]> = {
  CEILING: ["design", "room", "forekomster"],
  ROOM_VALIDATION: ["design", "room", "forekomster"],
  EXPLORE: ["design", "room", "forekomster"],
  ROOM_NUMBERING: ["design"],
  DROFUS_CHANGE_MANAGEMENT: ["design", "endringer", "room", "forekomster"],
};

export function readProjectModule(search: string): IMultiplacerModuleKey | undefined {
  const params = new URLSearchParams(search);
  const key = normalizeLegacyModuleKey((params.get("module") ?? params.get("mod"))?.toUpperCase());
  return ACTIVE_MODULE_KEYS.find((module) => module === key);
}

export function modulePageUrl(
  projectNo: string | number,
  module: IMultiplacerModuleKey,
  page = MODULE_PAGES[module][0]
) {
  return `/${projectNo}/${page}?module=${module}`;
}
